module.exports = __webpack_public_path__ + "static/DMSans-Regular-8bf156449ed8eb468ad42fddfe47e554.woff";